<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
     

    <v-card class="v-card-bottom-15">
      <v-card-title class="py-5">
        <h4>{{ use_language.order }}</h4> 
        <v-icon>mdi-chevron-right</v-icon>
        <span class="font-weight-regular body-1">{{ use_language.b2b_order }}</span>
        <v-spacer />
        <vue-excel-xlsx
          id="GetExcel"
          v-show="false"
          :data="datasetExcel"
          :columns="headerExcel"
          :file-name="use_language.order_b2b"
          :sheet-name="use_language.order_b2b"
        >
        </vue-excel-xlsx>
         <v-btn :elevation="1" outlined color="success" @click="ExportExcel()" class="ml-auto">
          <v-icon size="14" class="pr-1">fa-solid fa-download</v-icon>
          <span class="fn-12"> Export Excel </span>
          <span v-if="loadingExcel != 0">({{ loadingExcel }}%)</span>
        </v-btn>
        <v-btn dark color="primary" @click="$router.push('/add-order')" class="ml-2"> <v-icon left size="14">fa-plus</v-icon> {{ use_language.create_order }}</v-btn>
      </v-card-title>
    </v-card>
    <v-row justify="start" align="center" class="margin-card-status">
       <v-col cols="12" sm="4" md="4" lg="4" align="left">
        <v-card  class="v-card-bottom-15">
          <v-card-title >
            <v-row align="center">
              <v-col align="center">
                <h4 class='text-pink'> {{format_price(this.shippingStatusSummary.filter(i => i.shippingStatusID == 10)[0].orderTotalAmount)}} ฿</h4>
                <h4 class='pt-5 text-gray'> {{ use_language.offer_price }} ({{this.shippingStatusSummary.filter(i => i.shippingStatusID == 10)[0].statusCount}})</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
       <v-col cols="12" sm="4" md="4" lg="4" align="left">
        <v-card  class="v-card-bottom-15">
          <v-card-title>
            <v-row align="center">
              <v-col align="center">
                <h4 class='text-blue'> {{format_price(this.parcelStatusSummary.filter(i => i.parcelStatusID == 0)[0].orderTotalAmount)}} ฿</h4>
                <h4 class='pt-5 text-gray'> {{ use_language.waiting_to_ship }} ({{this.parcelStatusSummary.filter(i => i.parcelStatusID == 0)[0].statusCount}})</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" align="left">
        <v-card  class="v-card-bottom-15">
          <v-card-title >
            <v-row align="center">
              <v-col align="center">
                <h4 class='text-orange'> {{format_price(this.paymentStatusSummary.filter(i => i.paymentStatusID == 1)[0].orderTotalAmount)}} ฿</h4>
                <h4 class='pt-5 text-gray'> {{ use_language.awaiting_payment }} ({{ this.paymentStatusSummary.filter(i => i.paymentStatusID == 1)[0].statusCount}})</h4>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="v-card-bottom-15">
      <v-card-title>
        <v-icon size="20" color="primary">fa-sliders-h</v-icon><span class="py-2 ml-3">{{ use_language.search }}</span>
       
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="3" md="3">
            <v-select v-model="search_ordertype" :items="orderTypeOption"
              persistent-hint return-object dense outlined hide-details item-text="text"
              item-value="value"></v-select>
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-text-field :value="search_textType" @change="value => search_textType = value" :placeholder="use_language.enter_comma_to_search_multiple" hide-details dense outlined />
          </v-col>
          <v-col cols="12" md="2" lg="1" >
            <v-btn outlined class="mr-3" @click="btnOpenAdvanceSearchDialog()">
              <v-icon>mdi-filter-outline</v-icon>{{ use_language.advanced }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="2" lg="1">
            <v-btn dark color="primary" :loading="loading_btn" @click="search_data_b2b()" class="mr-3">
              {{use_language.search }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="3" md="3">
            <v-autocomplete
                v-model="sh_select_orderStatus_list"
                :items="data_orderStatus_list"
                item-text="text"
                item-value="value"
                outlined
                dense
                chips
                small-chips
                :label="use_language.select_order_status"
                multiple
                hide-details
              >
                <template v-slot:prepend-item>
                  <v-list-item @click="toggleOrder">
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectAllOrder"
                        :color="selectSomeOrder ? 'primary' : undefined"
                        :indeterminate="selectSomeOrder && !selectAllOrder"
                      >
                      </v-checkbox>
                    </v-list-item-action>
                    <v-list-item-title>{{ use_language.select_all }}</v-list-item-title>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template> 
                
                <template v-slot:selection="{ item, index }">

                  <span v-if="index < 1">{{ item.text }}</span>
                  <span v-else-if="index < 2">, {{ item.text }} </span>
                  <span v-if="index === 2" class="text-grey text-caption align-self-center"> (+{{
                    sh_select_orderStatus_list.length - 2 }} {{ use_language.other_options }}
                  </span>
                </template>

              </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" md="3">
            <v-autocomplete
                v-model="sh_select_paidStatus_list"
                :items="data_paidStatus_list"
                item-text="text"
                item-value="value"
                outlined
                dense
                chips
                small-chips
                :label="use_language.select_payment_status"
                multiple
                hide-details
              >
                <template v-slot:prepend-item>
                  <v-list-item @click="togglePaid">
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectAllPaid"
                        :color="selectSomePaid ? 'primary' : undefined"
                        :indeterminate="selectSomePaid && !selectAllPaid"
                      >
                      </v-checkbox>
                    </v-list-item-action>
                    <v-list-item-title>{{ use_language.select_all }}</v-list-item-title>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template> 
                
                <template v-slot:selection="{ item, index }">

                  <span v-if="index < 1">{{ item.text }}</span>
                  <span v-else-if="index < 2">, {{ item.text }} </span>
                  <span v-if="index === 2" class="text-grey text-caption align-self-center"> (+{{
                    sh_select_paidStatus_list.length - 2 }} {{ use_language.other_options }}
                  </span>
                </template>

              </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" md="3">
            <v-autocomplete
                v-model="sh_select_parcelStatus_list"
                :items="data_parcelStatus_list"
                item-text="text"
                item-value="value"
                outlined
                dense
                chips
                small-chips
                :label="use_language.select_parcel_status"
                multiple
                hide-details
              >
                <template v-slot:prepend-item>
                  <v-list-item @click="toggleParcel">
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectAllParcel"
                        :color="selectSomeParcel ? 'primary' : undefined"
                        :indeterminate="selectSomeParcel && !selectAllParcel"
                      >
                      </v-checkbox>
                    </v-list-item-action>
                    <v-list-item-title>{{ use_language.select_all }}</v-list-item-title>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template> 
                
                <template v-slot:selection="{ item, index }">

                  <span v-if="index < 1">{{ item.text }}</span>
                  <span v-else-if="index < 2">, {{ item.text }} </span>
                  <span v-if="index === 2" class="text-grey text-caption align-self-center"> (+{{
                    sh_select_parcelStatus_list.length - 2 }} {{ use_language.other_options }}
                  </span>
                </template>
              </v-autocomplete>
              </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row>
      <v-col cols="12" align="right">
        <span>{{ use_language.total_number }} {{totalRow}}</span>
      </v-col>
    </v-row>
    <v-card elevation="1">
      <v-card-text class="pa-0 v-card-bottom-15">
        <v-data-table v-if="orderReportTable_list != []" 
          :headers="orderReportTable_headers"
          :items="orderReportTable_list" 
          class="elevation-0 packhai-border-table" 
          hide-default-footer
          style="min-height: auto"
          :items-per-page="999999999" 
          :loading="loading_btn" 
          mobile-breakpoint="0">
          <template v-slot:item.no="{  item, index }">
            <!-- {{ totalRow - ((page - 1) * limits + index) }} -->
            <!-- {{ gen_num_data_table(orderReportTable_list.indexOf(item)) }} -->
            {{ gen_num_data_table(index) }}
          </template>
          <template v-slot:item.orderID="{ item }">
            <a href="#" class="text-info font-weight-bold" @click="detail_page(item)"> {{ format_order_id(item.orderID) }}</a>
          </template>
          <template v-slot:item.orderTotalAmount="{ item }">
            {{format_price(item.orderTotalAmount)}}
          </template>
          <template v-slot:item.shippingStatusID="{ item }">
              <span v-if="item.shippingStatusID == 10"> {{ use_language.offer_price }}</span>
              <span v-if="item.shippingStatusID == 30" style="color: #FFA500;">{{ use_language.sale_order }}</span>
              <span v-if="item.shippingStatusID == 70" style="color: #28a745;">{{ use_language.succeed }}</span>
              <span v-if="item.shippingStatusID == 90" style="color: #dc3545;">{{ use_language.cancel }}</span>
          </template>
          <template v-slot:item.parcelStatusID="{ item }">
            <span v-if="item.parcelStatusID == 0 || (item.parcelStatusID ==  null && item.shippingStatusID>=30 && item.shippingStatusID <= 70)" > {{ use_language.prepare_ship }}</span>
            <span v-if="item.parcelStatusID == 1"  style="color: #FFA500;"> {{ use_language.during_delivery }}</span>
            <span v-if="item.parcelStatusID == 5"  style="color: #28a745;"> {{ use_language.order_tab_count_success }}</span>
          </template>
          <template v-slot:item.paymentStatusID="{ item }">
              <span v-if=" item.paymentStatusID == 1 ||(item.paymentStatusID ==  null  && item.shippingStatusID>=30 && item.shippingStatusID <= 70)"> {{ use_language.awaiting_payment }}</span>
              <span v-if="item.paymentStatusID == 4"  style="color: #28a745;"> {{ use_language.paid_status }}</span>
          </template>
        </v-data-table>
      <v-row>
        <v-col cols="2"  md="3" lg="2"  xl="1" > </v-col>
        <v-col cols="8"  md="6" lg="8"  xl="10" align="center">
          <div class="text-center" @click="changePage()">
            <v-pagination
              v-model="page"
              :length="pageLength"
              :total-visible="7"
              color="primary"
            ></v-pagination>
          </div>
        </v-col>
        <v-col cols="2" md="3"  lg="2" xl="1" align="end">
          <v-select
            v-model="limits"
            :label="use_language.display_amount"
            :items="[10, 20, 50, 100, 500, 1000]"
            @change="LimitChange()"
            outlined
          ></v-select>
        </v-col>
      </v-row>
        </v-card-text>
    </v-card>
        

    <v-row>
      <v-col  cols="12" md="4">
        <v-card class="v-card-bottom-15" style="height: 320px; overflow-y: auto;">
          <v-card-title class="py-4">
            <v-icon size="20" color="success">fa-table</v-icon> <span class="ml-3">{{ use_language.order_status_ }}</span>
            <v-spacer/>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-0">
              <v-col >
                <div style="overflow-y: auto;">
                  <v-data-table :headers="shippingTable_headers" :items="shippingStatusSummary"
                    class="elevation-0 packhai-border-table " hide-default-footer
                    mobile-breakpoint="0">
                    <template v-slot:item.shippingStatusID="{ item }">
                     <span v-if="item.shippingStatusID == 10"> {{ use_language.offer_price }}</span>
                     <span v-if="item.shippingStatusID == 30" style="color: #FFA500;">{{ use_language.sale_order }}</span>
                      <span v-if="item.shippingStatusID == 70" style="color: #28a745;">{{ use_language.succeed }}</span>
                      <span v-if="item.shippingStatusID == 90" style="color: #dc3545;">{{ use_language.cancel }}</span>
                  </template>
                  <template v-slot:item.orderTotalAmount="{ item }">
                    {{format_price(item.orderTotalAmount)}}
                  </template>
                  </v-data-table>
                </div>
              </v-col>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="v-card-bottom-15" style="height: 320px; overflow-y: auto;">
          <v-card-title class="py-4">
            <v-icon size="20" color="success">fa-table</v-icon> <span class="ml-3">{{ use_language.parcel_status }}</span>
            <v-spacer/>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-0">
              <v-col >
                <div style="overflow-y: auto;">
                  <v-data-table :headers="parcelTable_headers" :items="parcelStatusSummary"
                    class="elevation-0 packhai-border-table " hide-default-footer
                    mobile-breakpoint="0">
                      <template v-slot:item.parcelStatusID="{ item }">
                     <span v-if="item.parcelStatusID == 0"> {{ use_language.prepare_ship }}</span>
                     <span v-if="item.parcelStatusID == 1"  style="color: #FFA500;"> {{ use_language.during_delivery }}</span>
                     <span v-if="item.parcelStatusID == 5"  style="color: #28a745;"> {{ use_language.order_tab_count_success }}</span>
                  </template>
                  </v-data-table>
                </div>
              </v-col>

          </v-card-text>
        </v-card>
      </v-col>
       <v-col cols="12" md="4">
        <v-card class="v-card-bottom-15" style="height: 320px; overflow-y: auto;">
          <v-card-title class="py-4">
            <v-icon size="20" color="success">fa-table</v-icon> <span class="ml-3">{{ use_language.payment_status }}</span>
            <v-spacer/>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-0">
              <v-col >
                <div style="overflow-y: auto;">
                  <v-data-table :headers="paymentTable_headers" :items="paymentStatusSummary"
                    class="elevation-0 packhai-border-table " hide-default-footer
                    mobile-breakpoint="0">
                    <template v-slot:item.paymentStatusID="{ item }">
                     <span v-if="item.paymentStatusID == 1"> {{ use_language.awaiting_payment }}</span>
                     <span v-if="item.paymentStatusID == 2"  style="color: #007bff;"> {{ use_language.credit }}</span>
                     <span v-if="item.paymentStatusID == 3"  style="color: #FFA500;"> {{ use_language.partially_paid }}</span>
                     <span v-if="item.paymentStatusID == 4"  style="color: #28a745;"> {{ use_language.paid_status }}</span>
                  </template>
                  <template v-slot:item.orderTotalAmount="{ item }">
                    {{format_price(item.orderTotalAmount)}}
                  </template>
                  </v-data-table>
                </div>
              </v-col>

          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
    <v-dialog v-model="advanceSearchDialog" scrollable :max-width="advanceDialogMaxWidth" persistent
      :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          <div>{{ use_language.advanced_search }}</div>
          <v-spacer />
          <v-btn icon @click="advanceSearchDialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />

        <v-card-text>
          <v-row class="align-items-center">
            <v-col cols="3" class="mt-1"><h4>{{ use_language.quotation_date_2 }} :</h4></v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_quotation_from" v-model="search_menu_quotation_from" :close-on-content-click="false"
                :return-value.sync="search_quotation_from" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_quotation_from" @change="value => computed_search_quotation_from = value"
                    autocomplete="off" :label="use_language.start_" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_quotation_from"
                  @input="search_menu_quotation_from = false, $refs.search_menu_quotation_from.save(search_quotation_from)" no-title
                  :allowed-dates="allowedDates" class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_quotation_to" v-model="search_menu_quotation_to" :close-on-content-click="false"
                :return-value.sync="search_quotation_to" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_quotation_to" @change="value => computed_search_quotation_to = value"
                    autocomplete="off" :label="use_language.end" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_quotation_to"
                  @input="search_menu_quotation_to = false, $refs.search_menu_quotation_to.save(search_quotation_to)" no-title
                  :allowed-dates="allowedDates" class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="align-items-center">
            <v-col cols="3" class="mt-1"><h4>{{ use_language.sale_order_date }} :</h4></v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_saleorder_from" v-model="search_menu_saleorder_from" :close-on-content-click="false"
                :return-value.sync="search_saleorder_from" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_saleorder_from" @change="value => computed_search_saleorder_from = value"
                    autocomplete="off" :label="use_language.start_" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_saleorder_from"
                  @input="search_menu_saleorder_from = false, $refs.search_menu_saleorder_from.save(search_saleorder_from)" no-title
                  :allowed-dates="allowedDates" class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_saleorder_to" v-model="search_menu_saleorder_to" :close-on-content-click="false"
                :return-value.sync="search_saleorder_to" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_saleorder_to" @change="value => computed_search_saleorder_to = value"
                    autocomplete="off" :label="use_language.end" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_saleorder_to"
                  @input="search_menu_saleorder_to = false, $refs.search_menu_saleorder_to.save(search_saleorder_to)" no-title
                  :allowed-dates="allowedDates" class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="align-items-center">
            <v-col cols="3" class="mt-1"><h4>{{ use_language.payment_success_date }} :</h4></v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_payment_from" v-model="search_menu_payment_from" :close-on-content-click="false"
                :return-value.sync="search_payment_from" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_payment_from" @change="value => computed_search_payment_from = value"
                    autocomplete="off" :label="use_language.start_" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_payment_from"
                  @input="search_menu_payment_from = false, $refs.search_menu_payment_from.save(search_payment_from)" no-title
                  :allowed-dates="allowedDates" class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_payment_to" v-model="search_menu_payment_to" :close-on-content-click="false"
                :return-value.sync="search_payment_to" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_payment_to" @change="value => computed_search_payment_to = value"
                    autocomplete="off" :label="use_language.end" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_payment_to"
                  @input="search_menu_payment_to = false, $refs.search_menu_payment_to.save(search_payment_to)" no-title
                  :allowed-dates="allowedDates" class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row class="align-items-center">
            <v-col cols="3" class="mt-1"><h4>{{ use_language.shipping_date }} :</h4></v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_send_from" v-model="search_menu_send_from" :close-on-content-click="false"
                :return-value.sync="search_send_from" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_send_from" @change="value => computed_search_send_from = value"
                    autocomplete="off" :label="use_language.start_" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_send_from"
                  @input="search_menu_send_from = false, $refs.search_menu_send_from.save(search_send_from)" no-title
                  class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-menu ref="search_menu_send_to" v-model="search_menu_send_to" :close-on-content-click="false"
                :return-value.sync="search_send_to" transition="scale-transition" offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computed_search_send_to" @change="value => computed_search_send_to = value"
                    autocomplete="off" :label="use_language.end" outlined prepend-inner-icon="mdi-calendar" readonly hide-details
                    dense v-on="on" clearable>
                  </v-text-field>
                </template>
                <v-date-picker v-model="search_send_to"
                  @input="search_menu_send_to = false, $refs.search_menu_send_to.save(search_send_to)" no-title
                  class="my-0">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-col cols="12" class="text-right pa-0">
            <v-btn color="primary" @click="search_data_b2b()"> {{ use_language.search }} </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from '@/website/components/Loading'
import Swal from "sweetalert2";
import axios from 'axios'
import { GChart } from 'vue-google-charts'
import { orderService_dotnet } from '@/website/global'
import { format_number, format_order_id, format_price, get_languages } from '@/website/global_function'
import { AlertError } from "@/website/global_alert";
import { header_token } from '@/website/backend/token'


export default {
  components: {
    Loading,
  },

  data: () => ({
    page_loading: false,
    loading: false,
    loading_btn: false,
    paidCount :0,
    paidAmount: 0,
    waitPaymentCount:0,
    waitPaymentAmount: 0,
    unpaidCount:0,
    unpaidAmount: 0,
    use_language: {},
    set_language: null,
    totalAmountOffer:0,
    offerCount:0,
    totalAmountDelivery:0,
    deliveryCount:0,
    totalAmountPayment:0,
    paymentCount:0,
    //search
    // headers-trap: text ต้องอ้าง use_language แต่ data() เป็น arrow function -> stub ไว้ แล้ว rebuild ใน created(); orderTypeOption ย้ายไป computed
    search_ordertype: { value: 1, text: '' },
    search_textType:null,
    advanceSearchDialog: false,
    advanceDialogMaxWidth: "700px",

    //start date from to
    search_menu_quotation_from: false,
    search_quotation_from: null,
    search_menu_quotation_to: false,
    search_quotation_to: null,
    
    search_menu_saleorder_from: false,
    search_saleorder_from: null,
    search_menu_saleorder_to: false,
    search_saleorder_to: null,

    search_menu_payment_from: false,
    search_payment_from: null,
    search_menu_payment_to: false,
    search_payment_to: null,

    search_menu_send_from: false,
    search_send_from: null,
    search_menu_send_to: false,
    search_send_to: null,
    //end

    // headers-trap: data_*Status_list ย้ายไป computed (อ้าง use_language, อ่านอย่างเดียว)
    sh_select_orderStatus_list:[],
    sh_select_paidStatus_list:[],
    sh_select_parcelStatus_list:[],
    // paginations
    page: 1,
    page_tmp: null,
    limits: 10,
    offsets: 0,
    pageLength: null,
    totalRow:0,
    allAmount: {
      quotationAmount: null,
      saleOrderAmount: null,
      waitPaymentAmount: null
    },

    datasetExcel: [],
    // headers-trap: headerExcel ย้ายไป computed (label อ้าง use_language, อ่านอย่างเดียว)
    loadingExcel: 0,

    orderReportTable_list: [],
    // headers-trap: *Table_headers ย้ายไป computed (text อ้าง use_language, อ่านอย่างเดียว)
    shippingStatusSummary: [{shippingStatusID:10,statusCount:0,orderTotalAmount:0},{shippingStatusID:30,statusCount:0,orderTotalAmount:0},{shippingStatusID:70,statusCount:0,orderTotalAmount:0},{shippingStatusID:90,statusCount:0,orderTotalAmount:0}],
    parcelStatusSummary: [{parcelStatusID: 0, statusCount: 0,orderTotalAmount:0},{parcelStatusID: 1, statusCount: 0,orderTotalAmount:0},{parcelStatusID: 5, statusCount: 0,orderTotalAmount:0}],
    paymentStatusSummary: [{paymentStatusID:1,statusCount:0,orderTotalAmount:0},{paymentStatusID:4,statusCount:0,orderTotalAmount:0}],
  }),

  computed: {
    // headers-trap: อาเรย์อ่านอย่างเดียวที่มี text/label อ้าง use_language -> ย้ายมา computed (guard use_language)
    orderTypeOption() {
      const l = this.use_language || {}
      return [
        { value: 1, text: l.order_number },
        { value: 2, text: l.quotation_number_label },
        { value: 3, text: l.sales_order_number },
        { value: 4, text: l.reference_number },
      ]
    },
    data_orderStatus_list() {
      const l = this.use_language || {}
      return [
        { value: 10, text: l.offer_price },
        { value: 30, text: l.sale_order },
        { value: 70, text: l.succeed },
        { value: 90, text: l.cancel },
      ]
    },
    data_paidStatus_list() {
      const l = this.use_language || {}
      return [
        { value: 1, text: l.awaiting_payment },
        { value: 4, text: l.paid_status },
      ]
    },
    data_parcelStatus_list() {
      const l = this.use_language || {}
      return [
        { value: 0, text: l.prepare_ship },
        { value: 1, text: l.during_delivery },
        { value: 5, text: l.order_tab_count_success },
      ]
    },
    headerExcel() {
      const l = this.use_language || {}
      return [
        { label: "OrderID", field: "orderID", width: 10 },
        { label: l.quotation, field: "quotationNumber", width: 50 },
        { label: l.sale_order, field: "saleOrderNumber", width: 30 },
        { label: l.quotation_date, field: "createdDateTime", width: 30 },
        { label: l.sale_date, field: "confirmedOrderDate", width: 30 },
        { label: l.amount_money, field: "orderTotalAmount", width: 30 },
        { label: l.customer, field: "shopCustomer", width: 30 },
        { label: l.order_status_, field: "shippingStatusID", width: 30 },
        { label: l.delivery_status, field: "parcelStatusID", width: 30 },
        { label: l.payment_status_, field: "paymentStatusID", width: 30 }
      ]
    },
    orderReportTable_headers() {
      const l = this.use_language || {}
      return [
        { text: l.number, align: 'center', value: 'no', width: '10px', sortable: false },
        { text: 'OrderID', align: 'center', value: 'orderID', width: '90px', sortable: false },
        { text: l.quotation, align: 'center', value: 'quotationNumber', width: '130px', sortable: false },
        { text: l.sale_order, align: 'center', value: 'saleOrderNumber', width: '130px', sortable: false },
        { text: l.quotation_date, align: 'center', value: 'createdDateTime', width: '120px', sortable: false },
        { text: l.sale_date, align: 'center', value: 'confirmedOrderDate', width: '120px', sortable: false },
        { text: l.amount_money, align: 'right', value: 'orderTotalAmount', width: '100px', sortable: false },
        { text: l.customer, align: 'left', value: 'shopCustomer', width: '180px', sortable: false },
        { text: l.order_status_, align: 'center', value: 'shippingStatusID', width: '120px', sortable: false },
        { text: l.delivery_status, align: 'center', value: 'parcelStatusID', width: '120px', sortable: false },
        { text: l.payment_status_, align: 'center', value: 'paymentStatusID', width: '120px', sortable: false },
      ]
    },
    shippingTable_headers() {
      const l = this.use_language || {}
      return [
        { text: l.status, align: 'center', value: 'shippingStatusID', width: '40%', sortable: false },
        { text: l.quantity, align: 'center', value: 'statusCount', width: '30%', sortable: false },
        { text: l.amount_money, align: 'right', value: 'orderTotalAmount', width: '30%', sortable: false },
      ]
    },
    parcelTable_headers() {
      const l = this.use_language || {}
      return [
        { text: l.status, align: 'center', value: 'parcelStatusID', width: '50%', sortable: false },
        { text: l.quantity, align: 'center', value: 'statusCount', width: '50%', sortable: false },
      ]
    },
    paymentTable_headers() {
      const l = this.use_language || {}
      return [
        { text: l.status, align: 'center', value: 'paymentStatusID', width: '40%', sortable: false },
        { text: l.quantity, align: 'center', value: 'statusCount', width: '30%', sortable: false },
        { text: l.amount_money, align: 'right', value: 'orderTotalAmount', width: '30%', sortable: false },
      ]
    },
    computed_search_quotation_from: {
      get() { return this.search_quotation_from ? this.search_quotation_from.trim() : '' },
      set(value) { this.search_quotation_from = value }
    },
    computed_search_quotation_to: {
      get() { return this.search_quotation_to ? this.search_quotation_to.trim() : '' },
      set(value) { this.search_quotation_to = value }
    },

    computed_search_saleorder_from: {
      get() { return this.search_saleorder_from ? this.search_saleorder_from.trim() : '' },
      set(value) { this.search_saleorder_from = value }
    },
    computed_search_saleorder_to: {
      get() { return this.search_saleorder_to ? this.search_saleorder_to.trim() : '' },
      set(value) { this.search_saleorder_to = value }
    },

    computed_search_payment_from: {
      get() { return this.search_payment_from ? this.search_payment_from.trim() : '' },
      set(value) { this.search_payment_from = value }
    },
    computed_search_payment_to: {
      get() { return this.search_payment_to ? this.search_payment_to.trim() : '' },
      set(value) { this.search_payment_to = value }
    },

    computed_search_send_from: {
      get() {
      return this.search_send_from ? this.search_send_from.trim() : '' },
      set(value) { this.search_send_from = value }
    },
    computed_search_send_to: {
      get() {
      return this.search_send_to ? this.search_send_to.trim() : '' },
      set(value) { this.search_send_to = value }
    },

    selectAllOrder() {
      return this.sh_select_orderStatus_list.length === this.data_orderStatus_list.length
    },
    selectSomeOrder() {
      return this.sh_select_orderStatus_list.length > 0
    },
    selectAllPaid() {
      return this.sh_select_paidStatus_list.length === this.data_paidStatus_list.length
    },
    selectSomePaid() {
      return this.sh_select_paidStatus_list.length > 0
    },
    selectAllParcel() {
      return this.sh_select_parcelStatus_list.length === this.data_parcelStatus_list.length
    },
    selectSomeParcel() {
      return this.sh_select_parcelStatus_list.length > 0
    },
  },


  async created() {

    //เก็บภาษามาไว้ใน use_language
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    // headers-trap: rebuild search_ordertype default หลังโหลด use_language
    this.search_ordertype = { value: 1, text: this.use_language.order_number }
    // await this.get_data_card()
    await this.get_data_b2b() 
  },

  methods: {
    btnOpenAdvanceSearchDialog() {
      this.advanceSearchDialog = true;
    },
    toggleOrder() {
      if (this.selectAllOrder) {
        this.sh_select_orderStatus_list = []
      } else {
        this.sh_select_orderStatus_list = []
        this.sh_select_orderStatus_list = this.data_orderStatus_list.map(x => x.value)
      }
    },
    togglePaid() {
      if (this.selectAllPaid) {
        this.sh_select_paidStatus_list = []
      } else {
        this.sh_select_paidStatus_list = []
        this.sh_select_paidStatus_list = this.data_paidStatus_list.map(x => x.value)
      }
    },
    toggleParcel() {
      if (this.selectAllParcel) {
        this.sh_select_parcelStatus_list = []
      } else {
        this.sh_select_parcelStatus_list = []
        this.sh_select_parcelStatus_list = this.data_parcelStatus_list.map(x => x.value)
      }
    },
    
    async LimitChange(){
      this.page=1;
      this.offsets=0;
      await this.get_data_b2b();
    },

    format_number,
    format_order_id,
    format_price,
    get_languages,
    AlertError,

    allowedDates: val => val <= new Date().toISOString().substr(0, 10),

    formatDates(date) {
      if (date == null) {
        return null
      } else {
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      }
    },

    set_format_date(val) {
      if (val != null) {
        var date_tmp = val.substring(0, 10)
        const date_split = date_tmp.split('-');
        var time_tmp = val.substring(11, 19)
        var set_dattime = date_split[2] + '-' + date_split[1] + '-' + date_split[0]
        return set_dattime
      } else {
        return ""
      }
    },

    set_format_date_time(val) {
      if (val != null) {
        var date_tmp = val.substring(0, 10)
        const date_split = date_tmp.split('-');
        var time_tmp = val.substring(11, 19)
        var set_dattime = date_split[2] + '-' + date_split[1] + '-' + date_split[0] + ' ' + time_tmp
        return set_dattime
      } else {
        return ""
      }
    },

    set_zero_date(num) {
      var num_tmp
      if (parseInt(num) >= 10) {
        num_tmp = num
      } else {
        num_tmp = '0' + num
      }
      return num_tmp
    },

    gen_num_data_table(index) {
      if (index != null && !this.loading) {
          // // แสดงลำดับจากน้อยไปมาก
          // const start = 1 + this.offsets
          // return format_number(start + index)
          // แสดงลำดับจากมากไปน้อย
          const start = this.totalRow - this.offsets
          return format_number(start - index)
      } else {
        return ""
      }
    },

    async get_data_b2b() {
      try{
        this.loading_btn = true
        let response = await axios.post(
          orderService_dotnet + 'Order/get-order-b2b',
          {
            "shopID": localStorage.getItem("shop_id"),
            "shippingStatusID":  this.sh_select_orderStatus_list.length === 0 ? [10,30,70,90]: this.sh_select_orderStatus_list ,
            "paidStatusID":  this.sh_select_paidStatus_list.length === 0 ? []: this.sh_select_paidStatus_list ,
            "parcelStatusID":  this.sh_select_parcelStatus_list.length === 0 ? []: this.sh_select_parcelStatus_list ,
            "orderID": this.search_ordertype.value ==1 && this.search_textType? this.search_textType : null,
            "quotationNumber": this.search_ordertype.value==2 && this.search_textType? this.search_textType : null,
            "saleOrderNumberNumber": this.search_ordertype.value==3 && this.search_textType? this.search_textType : null,
            "referenceNumber": this.search_ordertype.value==4 && this.search_textType? this.search_textType : null,
            "quotationFrom": this.search_quotation_from,
            "quotationTo": this.search_quotation_to,
            "saleOrderFrom": this.search_saleorder_from,
            "saleOrderTo": this.search_saleorder_to,
            "paymentFrom": this.search_payment_from,
            "paymentTo": this.search_payment_to,
            "sendFrom": this.search_send_from,
            "sendTo": this.search_send_to,
            "skip": this.offsets,
            "take": this.limits
          }, { headers: header_token }
        )
        if (response.data.length != 0) {
          this.orderReportTable_list= response.data.orderList.sort((a, b) => b.orderID - a.orderID);
          this.shippingStatusSummary=response.data.shippingStatusSummary
          this.parcelStatusSummary=response.data.parcelStatusSummary
          this.paymentStatusSummary=response.data.paymentStatusSummary
          this.totalRow=response.data.totalRows
          
          this.allAmount = {
            quotationAmount: response.data.quotationAmount,
            saleOrderAmount: response.data.saleOrderAmount,
            waitPaymentAmount: response.data.waitPaymentAmount
          }
        }
        this.pageLength =  (Math.ceil(response.data.totalRows/this.limits))
        if (this.pageLength <= 0) {
          this.pageLength = 1
        }
        this.pageTemp = this.page
        
        this.loading_btn = false
      } catch (e) {
        this.loading_btn = false
        this.$swal({
          type: 'warning',
          title: this.use_language.error_please_contact_department,
          text: e,
        })
        
      }
    },

    async ExportExcel(search) {
      this.datasetExcel = [];
      this.loadingExcel = 0;
      Swal.fire({
        position: "top",
        icon: "warning",
        text: this.use_language.warning_wait_excel,
        confirmButtonText: this.use_language.confirm,
        cancelButtonText: this.use_language.cancel,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.value) {
          var limits = 6;
          var offsets = 0;
          this.loadingExcel = 1;
          var total = this.totalRow;
          var round = parseInt(total / limits);
          if (limits * round < total) {
            round = round + 1;
          }

          for (var i = 1; i <= round; i++) {
            var data = await this.GetExportExcelProduct(limits, offsets);
            for (var j in data) {
              data[j].orderID = this.format_order_id(data[j].orderID);
              data[j].createdDateTime = this.set_format_date_time2(data[j].createdDateTime);
              data[j].confirmedOrderDate = this.set_format_date_time2(data[j].confirmedOrderDate);
              if (data[j].shippingStatusID == 10) {
                data[j].shippingStatusID = this.use_language.offer_price
              } else if (data[j].shippingStatusID == 30) {
                data[j].shippingStatusID = this.use_language.sale_order
              } else if (data[j].shippingStatusID == 70) {
                data[j].shippingStatusID = this.use_language.succeed
              } else if (data[j].shippingStatusID == 90) {
                data[j].shippingStatusID = this.use_language.cancel
              }

              if (data[j].parcelStatusID == 0 || (data[j].parcelStatusID ==  null && data[j].shippingStatusID >= 30 && data[j].shippingStatusID <= 70)) {
                data[j].parcelStatusID = this.use_language.prepare_ship
              } else if (data[j].parcelStatusID == 1) {
                data[j].parcelStatusID = this.use_language.during_delivery
              } else if (data[j].parcelStatusID == 5) {
                data[j].parcelStatusID = this.use_language.order_tab_count_success
              }

              if (data[j].paymentStatusID == 1) {
                data[j].paymentStatusID = this.use_language.awaiting_payment
              } else if (data[j].paymentStatusID == 4) {
                data[j].paymentStatusID = this.use_language.paid_status
              }
              this.datasetExcel.push(data[j]);
            }
            this.loadingExcel = parseInt((parseFloat(i) / parseFloat(round)) * parseFloat(100));
            offsets += limits;
          }

          for (var d in this.datasetExcel) {
            this.datasetExcel[d]["no"] = this.datasetExcel.length - parseInt(d);
          }

          this.loadingExcel = this.datasetExcel.length == 0 ? 0 : 100;
          document.getElementById("GetExcel").click();
        }
      });
    },
    async GetExportExcelProduct(limits, offsets) {
      try {
        let response = await axios.post(
          orderService_dotnet + 'Order/get-order-b2b',
          {
            "shopID": localStorage.getItem("shop_id"),
            "shippingStatusID":  this.sh_select_orderStatus_list.length === 0 ? [10,30,70,90]: this.sh_select_orderStatus_list ,
            "paidStatusID":  this.sh_select_paidStatus_list.length === 0 ? []: this.sh_select_paidStatus_list ,
            "parcelStatusID":  this.sh_select_parcelStatus_list.length === 0 ? []: this.sh_select_parcelStatus_list ,
            "orderID": this.search_ordertype.value ==1 && this.search_textType? this.search_textType : null,
            "quotationNumber": this.search_ordertype.value==2 && this.search_textType? this.search_textType : null,
            "saleOrderNumberNumber": this.search_ordertype.value==3 && this.search_textType? this.search_textType : null,
            "referenceNumber": this.search_ordertype.value==4 && this.search_textType? this.search_textType : null,
            "quotationFrom": this.search_quotation_from,
            "quotationTo": this.search_quotation_to,
            "saleOrderFrom": this.search_saleorder_from,
            "saleOrderTo": this.search_saleorder_to,
            "paymentFrom": this.search_payment_from,
            "paymentTo": this.search_payment_to,
            "sendFrom": this.search_send_from,
            "sendTo": this.search_send_to,
            "skip": offsets,
            "take": limits
          }, { headers: header_token }
        )
        if (response.data.orderList != null) {
          return response.data.orderList;
        } else {
          return [];
        }
      } catch (e) {
        AlertError(e.message);
        this.loading = false;
      }
    },

    detail_page (item) {
      window.open('order-detail?id='+item.orderID,'_blank');
    },

    async changePage() {
      if (this.pageLength!=1 && this.pageTemp!=this.page){
        this.offsets = (this.page*this.limits)-this.limits
        await this.get_data_b2b();
        this.pageTemp = this.page
      }
    },
    async get_data_card() {
      try{
        this.loading_btn = true
        let response = await axios.post(orderService_dotnet + 'Order/get-stat-b2b', {
          "shopID": localStorage.getItem("shop_id"),
        }, { headers: header_token })
        if (response.data.length != 0) {
           this.totalAmountOffer = response.data.totalAmountOffer,
           this.offerCount= response.data.offerCount,
           this.totalAmountDelivery= response.data.totalAmountDelivery,
           this.deliveryCount= response.data.deliveryCount,
           this.totalAmountPayment= response.data.totalAmountPayment,
           this.paymentCount= response.data.paymentCount
        }
        this.loading_btn = false
      } catch (e) {
        this.$swal({
          type: 'warning',
          title: this.use_language.error_please_contact_department,
          text: e,
        })
        this.loading_btn = false
      }
    },
   
    async search_data_b2b() {
      this.advanceSearchDialog=false
      this.page=1;
      this.offsets=0;
      await this.get_data_b2b()
      // await this.get_data_profit()
      // await this.get_data_expense()
    },

    set_format_date_time2(val) {
      if (val != null) {
        var date_tmp = val.substring(0, 10);
        const date_split = date_tmp.split("-");
        var time_tmp = val.substring(11, 19);
        var set_dattime = date_split[2] + "-" + date_split[1] + "-" + date_split[0] + " " + time_tmp;
        return set_dattime;
      } else {
        return "";
      }
    },
  }
}
</script>
<style scoped>
/* >>>.v-dialog {
        -webkit-box-shadow: none;
        box-shadow: none;
    } */

>>>.bex48-logo {
  width: 12.533vw;
  height: 11.2vw;
  display: block;
  /* margin: 8.8vw auto 1.6vw; */
  margin: 1.6vw auto 1.6vw;
}

>>>.slide-fade-enter-active {
  transition: all .3s ease;
}
.v-card-bottom-15{
    margin-bottom: 15px !important;
}
>>>.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

>>>.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateY(10px);
  opacity: 0;
}

.packhai-border-table {

  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.packhai-border-table thead {
  color: #f4f6ff;
}

.packhai-border-table thead tr th {
  font-weight: bold;
  font-size: 2rem;
}

.return-order-table {
  width: 100%;
}

.padding-for-order-dialog {
  padding: 0px !important;
}

>>>.margin-card-r-10 {
  margin-right: 0px;
}

>>>.margin-card-l-10 {
  margin-left: 0px;
}

@media screen and (min-width: 768px) {
  .return-order-table {
    width: 300px;
  }

  .padding-for-order-dialog {
    padding: 15px !important;
  }

  .margin-card-r-3 {
    margin-right: 10px;
  }

  .margin-card-l-3 {
    margin-left: 10px;
  }
}

.packhai-border-preview {
  border-top: solid 1px black;
  border-left: solid 1px black;
  border-right: solid 1px black;
  border-bottom: solid 1px black;
  border-radius: 10px;
}

.px-15 {
  padding-left: 15px;
  padding-right: 15px;
}

.fz-12 {
  font-size: 12px !important;
}

.fz-14 {
  font-size: 14px !important;
}

.text-pink {
  color: 	#ff69b4;
  font-weight: bold;
}

.text-blue {
  color: #007bff;
  font-weight: bold;
}

.text-orange {
  color: #ff8d22;
  font-weight: bold;
}

.text-gray {
  color: #575757;
  font-weight: bold;
}

.custom-title {
  padding: 5 !important;
}
</style>
